import { router } from '@inertiajs/vue3'

let loaded = false
let storedTagId = null

export function loadBingUetScript(tagId) {
  const id = tagId || storedTagId
  return new Promise((resolve) => {
    if (loaded) { resolve(); return }
    loaded = true

    const script = document.createElement('script')
    script.src = '//bat.bing.com/bat.js'
    script.async = true
    script.onload = script.onreadystatechange = function () {
      const s = this.readyState
      if (s && s !== 'loaded' && s !== 'complete') return

      const uetConfig = { ti: id }
      uetConfig.q = window.uetq
      window.uetq = new UET(uetConfig)
      window.uetq.push('pageLoad')
      resolve()
    }
    script.onerror = resolve
    document.head.appendChild(script)
  })
}

export default {
  install(app, options = {}) {
    if (import.meta.env.SSR) {
      app.config.globalProperties.$uetq = () => {}
      app.provide('uetq', () => {})
      return
    }

    const { enabled = true, uet_tag_id, autoLoad = true } = options
    if (!enabled || !uet_tag_id) {
      app.config.globalProperties.$uetq = () => {}
      app.provide('uetq', () => {})
      return
    }

    storedTagId = uet_tag_id

    // Initialize queue immediately so events pushed before bat.js loads are captured
    window.uetq = window.uetq || []

    if (autoLoad) {
      const loadWhenIdle = () => {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(() => {
            loadBingUetScript(uet_tag_id)
          }, { timeout: 5000 })
        } else {
          setTimeout(() => loadBingUetScript(uet_tag_id), 5000)
        }
      }

      loadWhenIdle()
    }

    // Track Inertia navigations as page views
    router.on('navigate', () => {
      if (window.uetq && typeof window.uetq.push === 'function') {
        window.uetq.push('pageLoad')
      }
    })

    // Provide helper function
    const uetqPush = (...args) => {
      if (window.uetq) {
        window.uetq.push(...args)
      }
    }

    app.config.globalProperties.$uetq = uetqPush
    app.provide('uetq', uetqPush)
  }
}
